import { 
  NoteListenerState, 
  noteListenerActions
} from './../types/noteListenerTypes';
import { 
  NOTE_WAS_CREATED,
  NOTE_WAS_DELETED,
  NOTE_WAS_EDITED,
} from '../constants/index';

const initialState: NoteListenerState = {
  walkId: 0,
  noteId: 0,
  action: ''
}

const noteListenerReducer = (state = initialState, action: noteListenerActions) => {
  const payload = action.payload;

  switch(action.type){
    case NOTE_WAS_CREATED:
      return {
        ...state,
        walkId: payload.walkId,
        noteId: payload.walkId,
        action: payload.action
      }

    case NOTE_WAS_EDITED:
      return {
        ...state,
        walkId: payload.walkId,
        noteId: payload.walkId,
        action: payload.action
      }

    case NOTE_WAS_DELETED:
      return {
        ...state,
        walkId: payload.walkId,
        noteId: payload.walkId,
        action: payload.action
      }
        
    default: 
      return state
  }
}

export default noteListenerReducer;
